import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import '../../styles/AnnouncementBar/announcement-bar.css';

const ANNOUNCEMENT_ROOT_ID = 'announcement-root';

export default function AnnouncementBar() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    document.documentElement.classList.toggle('has-announcement-bar', isHome);
    return () => {
      document.documentElement.classList.remove('has-announcement-bar');
    };
  }, [isHome]);

  if (!isHome) {
    return null;
  }

  const mount = document.getElementById(ANNOUNCEMENT_ROOT_ID);
  if (!mount) {
    return null;
  }

  return createPortal(
    <div className="announcement-bar" role="region" aria-label="Annonce promotionnelle">
      <p className="announcement-bar__text">
      NOS COMPAGNONS LUMINEUX À 21,90 € • LIVRAISON OFFERTE EN POINT RELAIS           
      </p>
    </div>,
    mount
  );
}
